import { render, staticRenderFns } from "./MicrosoftEntraId.vue?vue&type=template&id=53fc4f48"
import script from "./MicrosoftEntraId.vue?vue&type=script&lang=js"
export * from "./MicrosoftEntraId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports